var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BrandingPreviewBase } from "../../branding/branding-preview-base";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { StepEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { SyndicateBrandingText } from "./branding-steps/syndicate-branding-text";
import { SyndicateBrandingColors } from "./branding-steps/syndicate-branding-colors";
import { EventAggregator } from "aurelia-event-aggregator";
import { SyndicateBrandingImages } from "./branding-steps/syndicate-branding-images";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandClientService, SyndicateKeyHelper, TemplateType } from "../../../../../services/modules/brand-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { CacheClient } from "../../../../../services/basics/client-caching.service";
import { SyndicateBrandingAds } from "./branding-steps/syndicate-branding-ads";
import { SyndicateBrandingAssets } from "./branding-steps/syndicate-branding-assets";
import { JsonLockClientService } from "../../../../../services/modules/json-lock-client-service";
var SyndicateBrandingDialog = /** @class */ (function (_super) {
    __extends(SyndicateBrandingDialog, _super);
    function SyndicateBrandingDialog(element, notificationService, i18N, eventAggregator, lookupClientService, cacheClient, syndicateBrandingText, syndicateBrandingImages, syndicateBrandingAds, syndicateBrandingColors, syndicateBrandingAssets, tokenClientService, dialogClientService, brandClientService, attachmentClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.syndicateBrandingText = syndicateBrandingText;
        _this.syndicateBrandingImages = syndicateBrandingImages;
        _this.syndicateBrandingAds = syndicateBrandingAds;
        _this.syndicateBrandingColors = syndicateBrandingColors;
        _this.syndicateBrandingAssets = syndicateBrandingAssets;
        return _this;
    }
    SyndicateBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Syndicate];
    };
    SyndicateBrandingDialog.prototype.getBrandTemplateInternalName = function () { return this.item.navigationInfo.brandTemplateInternalName; };
    SyndicateBrandingDialog.prototype.getBrandThemeInternalName = function () { return this.item.navigationInfo.brandThemeInternalName; };
    SyndicateBrandingDialog.prototype.getBrandingSteps = function () {
        return [{
                title: this.i18N.tr('syndicate'),
                step: StepEnum.SyndicateBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("syndicate-branding-text"),
                        vm: this.syndicateBrandingText,
                        show: true,
                        view: '../../app/admin/syndicate/dialogs/branding-steps/syndicate-branding-text.html'
                    },
                    {
                        title: this.i18N.tr("syndicate-branding-images"),
                        vm: this.syndicateBrandingImages,
                        show: true,
                        view: '../../app/admin/syndicate/dialogs/branding-steps/syndicate-branding-images.html'
                    },
                    {
                        title: this.i18N.tr("syndicate-branding-colors"),
                        vm: this.syndicateBrandingColors,
                        show: true,
                        view: '../../app/admin/syndicate/dialogs/branding-steps/syndicate-branding-colors.html'
                    }
                ]
            },
            {
                title: this.i18N.tr('assets'),
                step: StepEnum.SyndicateAssets,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("syndicate-branding-images"),
                        vm: this.syndicateBrandingAssets,
                        show: true,
                        view: '../../app/admin/syndicate/dialogs/branding-steps/syndicate-branding-assets.html'
                    }
                ]
            },
            {
                title: this.i18N.tr('ads'),
                step: StepEnum.SyndicateAdsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("syndicate-branding-ads"),
                        vm: this.syndicateBrandingAds,
                        show: true,
                        view: '../../app/admin/syndicate/dialogs/branding-steps/syndicate-branding-ads.html'
                    }
                ]
            }];
    };
    SyndicateBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.navigationInfo.brandId,
            brandName: this.item.navigationInfo.brandName,
            brandLanguages: this.item.navigationInfo.brandLanguages
        };
    };
    SyndicateBrandingDialog.prototype.getImages = function () {
        return [this.syndicateBrandingImages.model, this.syndicateBrandingAds.model.image];
    };
    SyndicateBrandingDialog.prototype.getRoute = function () {
        var key = SyndicateKeyHelper.getKey(this.item.name);
        return "syndicate/".concat(this.item.brandLotteryId, "/").concat(this.item.syndicateId, "/").concat(key);
    };
    SyndicateBrandingDialog.prototype.includesNavigationInfo = function () {
        return true;
    };
    SyndicateBrandingDialog.prototype.getRouteAdditionalData = function () {
        return "syndicateId=".concat(this.item.syndicateId);
    };
    SyndicateBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator,
            LookupClientService, CacheClient, SyndicateBrandingText, SyndicateBrandingImages,
            SyndicateBrandingAds, SyndicateBrandingColors, SyndicateBrandingAssets,
            TokenClient, DialogClientService, BrandClientService,
            AttachmentClientService, JsonLockClientService])
    ], SyndicateBrandingDialog);
    return SyndicateBrandingDialog;
}(BrandingPreviewBase));
export { SyndicateBrandingDialog };
